import { breakpoint } from '@carvana/helios-layout';
import { canvas, spacing, text } from '@carvana/helios-styles';
import { body, heading } from '@carvana/helios-typography';
import styled from 'styled-components';

const Background = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const ContentCenter = styled.div`
  display: flex;
  justify-content: center;
  max-width: 512px;
  padding: 0px 24px ${spacing['4Xl']} 24px;
  background-color: ${canvas.default};

  ${breakpoint.sm`
    padding: 0px 0px ${spacing['4Xl']} 0px;
    max-width: 704px;
  `}

  ${breakpoint.md`
    padding: 0px 32px 40px 32px;
    min-width: unset;
    max-width: 1056px;
    width: unset;
  `}
`;

const Container = styled.div`
  width: 100%;
  ${breakpoint.sm`
    max-width: 959px;
  `}
`;

const Header = styled.h2`
  ${heading['2Xl']};
  color: ${text.strong};
  margin-bottom: ${spacing['4Xl']};

  ${breakpoint.md`
    ${heading['3Xl']};
    margin-bottom: ${spacing['5Xl']};
  `}
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoint.sm`
    flex-direction: row;
  `}
`;

const Step = styled.div`
  &:not(:last-child) {
    margin-bottom: ${spacing['3Xl']};
  }

  ${breakpoint.sm`
    width: 202px;
    &:not(:last-child) {
      margin-bottom: 0px;
      margin-right: ${spacing['5Xl']};
    }
  `}

  ${breakpoint.md`
    width: unset;
    min-width: 290px;
    max-width: 320px;
  `}
`;

const StepDescription = styled.p`
  ${body.md};
  color: ${text.default};
`;

const StepIcon = styled.div`
  margin-right: ${spacing.lg};
`;

const StepHeadline = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.md};
`;

const StepTitle = styled.h3`
  ${heading.lg};
  color: ${text.strong};
`;

export {
  Background,
  ContentCenter,
  Container,
  Header,
  Step,
  StepsContainer,
  StepDescription,
  StepHeadline,
  StepIcon,
  StepTitle
};
